import React, { useContext } from 'react';
import { ModalState } from '../hoc/confirmation-dialog-hoc';

export interface ConfirmationDialogType {
  openModal: (params: ModalState) => void;
  closeModal: () => void;
}

export const ConfirmationDialogContext = React.createContext<ConfirmationDialogType | null>(null);

export const useConfirmationDialogContext = () => {
  const context = useContext(ConfirmationDialogContext);
  if (!context) {
    throw new Error('Confirmation dialog context has not been setup');
  }
  return context;
};
